var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIosIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.08842 5.4167C8.43142 5.4167 7.41441 4.6697 6.34341 4.6967C4.93041 4.7147 3.63441 5.5157 2.90541 6.7847C1.43841 9.3317 2.52741 13.0937 3.95841 15.1637C4.66041 16.1717 5.48841 17.3057 6.58641 17.2697C7.63941 17.2247 8.03542 16.5857 9.31342 16.5857C10.5824 16.5857 10.9424 17.2697 12.0584 17.2427C13.1924 17.2247 13.9124 16.2167 14.6054 15.1997C15.4064 14.0297 15.7394 12.8957 15.7574 12.8327C15.7304 12.8237 13.5524 11.9867 13.5254 9.4667C13.5074 7.3607 15.2444 6.3527 15.3254 6.3077C14.3354 4.8587 12.8144 4.6967 12.2834 4.6607C10.8974 4.5527 9.73642 5.4167 9.08842 5.4167ZM11.4284 3.2927C12.0134 2.5907 12.4004 1.6097 12.2924 0.637695C11.4554 0.673695 10.4474 1.1957 9.84442 1.8977C9.30442 2.5187 8.83642 3.5177 8.96242 4.4717C9.88942 4.5437 10.8434 3.9947 11.4284 3.2927Z",
    fill: "#1B1B1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIosIcon);
export default __webpack_public_path__ + "static/media/ios-icon.078b208cc595b0f6912f71f4d78b0492.svg";
export { ForwardRef as ReactComponent };